<div class="checkbox-container">
    <input [name]="name"
           [id]="name"
           type="checkbox"
           [(ngModel)]="value"
           (ngModelChange)="onNgModelChanged()"
           (blur)="onBlur()"
           (focus)="onFocus()"
           [disabled]="isDisabled">


    <label [for]="name" class="no-select">
        <div class="activity-indicator">
            <div class="border">
                <i class="fa fa-check-square" *ngIf="value"></i>
            </div>

        </div>

        <div class="value-container">
            <ng-content></ng-content>
        </div>

    </label>
</div>


